import SportCodes from "../common/sport-codes";
import FootballGame from "../football/football-game";

export default class FlagFootballGame extends FootballGame {
    constructor(event) {
        super(event);
        this.sportCode = SportCodes.FlagFootball;
    }
}
